// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { batchDeleteAssistantConnectionAssociationsRequestToJson, batchSetConnectionAssistantRequestToJson, deleteConnectionRequestToJson, getConnectionRequestToJson, getConnectionResponseFromJson, listConnectionsRequestToJson, listConnectionsResponseFromJson, setConnectionAssistantRequestToJson, upsertConnectionRequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function upsertConnection(request) {
    await fetchRpc('ai_assistants.v1alpha1.ConnectionService/UpsertConnection', upsertConnectionRequestToJson(request));
}
export function upsertConnection$(request, options) {
    return defer(() => upsertConnectionWithTransport$(getGlobalTransport(), request, options));
}
export function upsertConnectionWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.ConnectionService/UpsertConnection', upsertConnectionRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function getConnection(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.ConnectionService/GetConnection', getConnectionRequestToJson(request));
    return getConnectionResponseFromJson(raw);
}
export function getConnection$(request, options) {
    return defer(() => getConnectionWithTransport$(getGlobalTransport(), request, options));
}
export function getConnectionWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.ConnectionService/GetConnection', getConnectionRequestToJson(request), options)
        .pipe(map(resp => getConnectionResponseFromJson(resp)));
}
export async function deleteConnection(request) {
    await fetchRpc('ai_assistants.v1alpha1.ConnectionService/DeleteConnection', deleteConnectionRequestToJson(request));
}
export function deleteConnection$(request, options) {
    return defer(() => deleteConnectionWithTransport$(getGlobalTransport(), request, options));
}
export function deleteConnectionWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.ConnectionService/DeleteConnection', deleteConnectionRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function listConnections(request) {
    const raw = await fetchRpc('ai_assistants.v1alpha1.ConnectionService/ListConnections', listConnectionsRequestToJson(request));
    return listConnectionsResponseFromJson(raw);
}
export function listConnections$(request, options) {
    return defer(() => listConnectionsWithTransport$(getGlobalTransport(), request, options));
}
export function listConnectionsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.ConnectionService/ListConnections', listConnectionsRequestToJson(request), options)
        .pipe(map(resp => listConnectionsResponseFromJson(resp)));
}
export async function setConnectionAssistant(request) {
    await fetchRpc('ai_assistants.v1alpha1.ConnectionService/SetConnectionAssistant', setConnectionAssistantRequestToJson(request));
}
export function setConnectionAssistant$(request, options) {
    return defer(() => setConnectionAssistantWithTransport$(getGlobalTransport(), request, options));
}
export function setConnectionAssistantWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.ConnectionService/SetConnectionAssistant', setConnectionAssistantRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function batchSetConnectionAssistant(request) {
    await fetchRpc('ai_assistants.v1alpha1.ConnectionService/BatchSetConnectionAssistant', batchSetConnectionAssistantRequestToJson(request));
}
export function batchSetConnectionAssistant$(request, options) {
    return defer(() => batchSetConnectionAssistantWithTransport$(getGlobalTransport(), request, options));
}
export function batchSetConnectionAssistantWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.ConnectionService/BatchSetConnectionAssistant', batchSetConnectionAssistantRequestToJson(request), options)
        .pipe(map(() => undefined));
}
export async function batchDeleteAssistantConnectionAssociations(request) {
    await fetchRpc('ai_assistants.v1alpha1.ConnectionService/BatchDeleteAssistantConnectionAssociations', batchDeleteAssistantConnectionAssociationsRequestToJson(request));
}
export function batchDeleteAssistantConnectionAssociations$(request, options) {
    return defer(() => batchDeleteAssistantConnectionAssociationsWithTransport$(getGlobalTransport(), request, options));
}
export function batchDeleteAssistantConnectionAssociationsWithTransport$(transport, request, options) {
    return transport
        .post('ai_assistants.v1alpha1.ConnectionService/BatchDeleteAssistantConnectionAssociations', batchDeleteAssistantConnectionAssociationsRequestToJson(request), options)
        .pipe(map(() => undefined));
}
